import { ALERT_STATUS } from "~/constants/alert";
import { WIDTH_NG } from "~/assets/js/constants";
import { translateAlert } from "~/utils/alert";

export const toAlert = (item) => ({
  id: item.id,
  status: item.status,
  msg: item.msg,
  template: item.template,
  templateValues: item.templateValues,
  agentId: item.agent?.id,
  computer: item.agent?.computerName,
  vaccine: item.vaccine?.name,
  category: item.vaccine?.category,
  agency: item.agency?.name,
  createdOn: item.createdOn,
  inactive: item.status === ALERT_STATUS.REJECTED || item.status === ALERT_STATUS.RESOLVED,
});

export const toAlertList = (items = []) => items.map(toAlert);

const TABLE_MAIN = "vaccine.name";

const HEADER_SIZES_FULL = [WIDTH_NG.LG, WIDTH_NG.MD, WIDTH_NG.LG, WIDTH_NG.LG, WIDTH_NG["3XL"], 38];

const HEADER_SIZES_USER = [WIDTH_NG.LG, WIDTH_NG.MD, WIDTH_NG.LG, WIDTH_NG["3XL"], 38];

function toStatusStyle(status) {
  if (status === ALERT_STATUS.ACTIVE) return { state: "error" };
  if (status === ALERT_STATUS.REJECTED) return { state: "warning" };
  if (status === ALERT_STATUS.RESOLVED) return { state: "ok", icon: "s2-icon-check-solid" };
  return {};
}

export const toAlertTable = (items, { isAdminLike, canAct, $t, $d }) => {
  const headers = [
    { id: "vaccine.name", label: $t("alerts.headers.vaccineName"), sortable: true },
    { id: "category", label: $t("vaccines.edit.category"), sortable: true },
    {
      id: isAdminLike ? "agency.name" : "agent.computerName",
      label: $t(isAdminLike ? "alerts.headers.agencyName" : "alerts.headers.computerName"),
      sortable: true,
    },
  ];

  if (isAdminLike) {
    headers.push({
      id: "agent.computerName",
      label: $t("alerts.headers.computerName"),
      sortable: true,
    });
  }

  headers.push(
    { id: "msg", label: $t("alerts.headers.message"), sortable: true },
    { id: "createdOn", label: $t("alerts.headers.date"), sortable: true },
  );

  const rows = items.map((alert) => {
    const actions = [];

    if (!alert.inactive && canAct) {
      actions.push(
        {
          id: "alert-resolve",
          icon: "s2-icon-check-solid",
          label: $t("alerts.resolve"),
          active: false,
          loading: false,
        },
        {
          id: "alert-reject",
          icon: "s2-icon-triangle-exclamation-solid",
          label: $t("alerts.reject"),
          active: false,
          loading: false,
        },
      );
    }

    if (alert.template !== "agentUninstalled") {
      actions.push({
        id: "alert-open",
        icon: "s2-icon-eye-regular",
        label: $t("generic.open"),
        active: false,
        loading: false,
      });
    }

    const columns = [
      { id: "vaccine.name", type: "text", data: { label: alert.vaccine ?? "" } },
      {
        id: "category",
        type: "text",
        data: { label: alert.category ? $t(`vaccines.edit.rules.${alert.category}`) : "" },
      },
      {
        id: isAdminLike ? "agency.name" : "agent.computerName",
        type: "text",
        data: { label: isAdminLike ? alert.agency ?? "" : alert.computer ?? "" },
      },
    ];

    if (isAdminLike) {
      columns.push({
        id: "agent.computerName",
        type: "text",
        data: { label: alert.computer ?? "" },
      });
    }

    columns.push(
      { id: "msg", type: "text", data: { label: translateAlert(alert, $t) } },
      {
        id: "createdOn",
        type: "text",
        data: { label: $d(new Date(alert.createdOn * 1000), "medium") },
      },
    );

    return {
      ...alert,
      actions,
      columns,
      ...toStatusStyle(alert.status),
    };
  });

  return {
    main: TABLE_MAIN,
    headers,
    rows,
    sizes: isAdminLike ? HEADER_SIZES_FULL : HEADER_SIZES_USER,
  };
};
